import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { QueryClient } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
// import { useIsIdTokenValid } from '../../me/isIdTokenValid';
import { useAuth } from '@msrceng/auth';
/**
 * Shortcut for whether auth is actually ready and whether this item cares about auth.
 *
 * > WARNING: Defaults to auth required, and you *must* explicitly declare your endpoint doesn't care about auth.
 */
export const useOApiAuthReady = (isAuthRequired = true) => {
    const { inProgress, instance, accounts } = useMsal();
    const { isApiTokenLoaded } = useAuth();
    // ID token expiries are currently not working.
    // const idTokenValid = useIsIdTokenValid();
    const account = instance.getActiveAccount() || accounts[0];
    // If we're not logged in, we're not ready for auth'ed requests.
    const isAuthenticatedToApi = useMemo(() => !!(account === null || account === void 0 ? void 0 : account.idTokenClaims) &&
        isApiTokenLoaded &&
        // If login/out is in progress, we're not ready for auth'ed requests.
        inProgress === InteractionStatus.None, // User's id token is valid
    // idTokenValid,
    // If we have any error, we're not ready for auth'ed requests
    // !errorSilent &&
    // !error,
    [account, inProgress, isApiTokenLoaded]);
    useEffect(() => {
        // When the user logs in, reload page data.
        if (isAuthenticatedToApi) {
            const qc = new QueryClient();
            qc.refetchQueries();
        }
    }, [isAuthenticatedToApi]);
    const isConfigured = !!axios.defaults.baseURL && isAuthenticatedToApi;
    return isAuthRequired ? isConfigured : true;
};
